import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ProfileService } from '../../services/profile.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnChanges {
  @Input() systemStatus: 'open' | 'busy' | 'closed' = 'open';
  @Input() waitingCount: number = 0;
  @Input() currentView: 'requests' | 'history' = 'requests';
  @Output() systemStatusChange = new EventEmitter<'open' | 'busy' | 'closed'>();
  @Output() navigateToRequests = new EventEmitter<void>();
  @Output() navigateToHistory = new EventEmitter<void>();

  constructor(
    private authService: AuthService,
    private router: Router,
    private profileService: ProfileService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['waitingCount']) {
      console.log('📢 Sidebar: waitingCount değişti:', changes['waitingCount'].previousValue, '->', changes['waitingCount'].currentValue);
    }
  }

  get isSystemOpen(): boolean {
    return this.systemStatus !== 'closed';
  }

  get currentUser() {
    return this.authService.getCurrentUser();
  }

  getProfilePictureUrl(): string {
    const user = this.currentUser;
    if (user && (user as any).profile_picture_url) {
      return `url(${this.profileService.getProfilePictureUrl((user as any).profile_picture_url)})`;
    }
    return '';
  }

  onChangeStatus(event: Event, status: 'open' | 'busy' | 'closed'): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.systemStatus === status) {
      return;
    }
    this.systemStatusChange.emit(status);
  }

  onNavigateToRequests(): void {
    if (this.currentView !== 'requests') {
      this.navigateToRequests.emit();
    }
  }

  onNavigateToHistory(): void {
    if (this.currentView !== 'history') {
      this.navigateToHistory.emit();
    }
  }

  navigateToProfile(): void {
    this.router.navigate(['/profile']);
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}

